import * as Yup from "yup";

export const ProfileSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("The email address format you have entered is invalid")
    .required("Email address is required"),
  first: Yup.string()
    .trim()
    .required("First name is required")
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be less then 50 characters")
    .matches(/^[A-Z a-z]+$/, {
      message: "Please enter a valid name without numbers",
    }),
  last: Yup.string()
    .trim()
    .required("Last name is required")
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name must be less then 50 characters")
    .matches(/^[A-Z a-z]+$/, {
      message: "Please enter a valid name without numbers",
    }),
  address1: Yup.string()
    .trim()
    .min(2, "Address must be at least 2 characters")
    .max(500, "Address must be less then 500 characters")
    .required("Address is required")
    .matches(/^[#.0-9a-zA-Z\s,-]+$/, {
      message: "Please enter a valid address",
    }),
  city: Yup.string()
    .trim()
    .required("City is required")
    .min(2, "City must be at least 2 characters")
    .max(50, "City must be less then 50 characters")
    .matches(/^[A-Z a-z]+$/, {
      message: "Please enter a valid city without numbers",
    }),
  state: Yup.object().shape({
    value: Yup.string().trim().required("Field is required"),
    label: Yup.string().trim(),
  }),
  zipCode: Yup.string()
    .trim()
    .required("Field is required")
    .min(5, "Invalid zip code")
    .max(10, "Invalid zip code"),
  specialty: Yup.object().shape({
    value: Yup.string().trim().required("Field is required"),
    label: Yup.string().trim(),
  }),
});
